import { render, staticRenderFns } from "./AuthRegPopup.vue?vue&type=template&id=e4e88110&"
import script from "./AuthRegPopup.vue?vue&type=script&lang=js&"
export * from "./AuthRegPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports